/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { FileView } from '../models';
import { InvestigatorWorkingPaperViewIEnumerableResponse } from '../models';
import { InvestigatorWorkingPaperViewResponse } from '../models';
/**
 * InvestigatorWorkingPaperApi - axios parameter creator
 * @export
 */
export const InvestigatorWorkingPaperApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Returns Investigator Working Paper File
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigatorWorkingPaperGetFileByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet: async (investigatorWorkingPaperId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigatorWorkingPaperId' is not null or undefined
            if (investigatorWorkingPaperId === null || investigatorWorkingPaperId === undefined) {
                throw new RequiredError('investigatorWorkingPaperId','Required parameter investigatorWorkingPaperId was null or undefined when calling apiV2InvestigatorWorkingPaperGetFileByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet.');
            }
            const localVarPath = `/api/v2/InvestigatorWorkingPaper/GetFileByInvestigatorWorkingPaperId/{investigatorWorkingPaperId}`
                .replace(`{${"investigatorWorkingPaperId"}}`, encodeURIComponent(String(investigatorWorkingPaperId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA Admin | Returns Investigator Working Paper File Stream
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigatorWorkingPaperGetFileStreamByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet: async (investigatorWorkingPaperId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigatorWorkingPaperId' is not null or undefined
            if (investigatorWorkingPaperId === null || investigatorWorkingPaperId === undefined) {
                throw new RequiredError('investigatorWorkingPaperId','Required parameter investigatorWorkingPaperId was null or undefined when calling apiV2InvestigatorWorkingPaperGetFileStreamByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet.');
            }
            const localVarPath = `/api/v2/InvestigatorWorkingPaper/GetFileStreamByInvestigatorWorkingPaperId/{investigatorWorkingPaperId}`
                .replace(`{${"investigatorWorkingPaperId"}}`, encodeURIComponent(String(investigatorWorkingPaperId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigator Working Paper By InvestigatorWorkingPaperId
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigatorWorkingPaperGetInvestigatorWorkingPaperByIdInvestigatorWorkingPaperIdGet: async (investigatorWorkingPaperId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigatorWorkingPaperId' is not null or undefined
            if (investigatorWorkingPaperId === null || investigatorWorkingPaperId === undefined) {
                throw new RequiredError('investigatorWorkingPaperId','Required parameter investigatorWorkingPaperId was null or undefined when calling apiV2InvestigatorWorkingPaperGetInvestigatorWorkingPaperByIdInvestigatorWorkingPaperIdGet.');
            }
            const localVarPath = `/api/v2/InvestigatorWorkingPaper/GetInvestigatorWorkingPaperById/{investigatorWorkingPaperId}`
                .replace(`{${"investigatorWorkingPaperId"}}`, encodeURIComponent(String(investigatorWorkingPaperId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigator Working Papers By InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigatorWorkingPaperGetInvestigatorWorkingPapersByIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigatorWorkingPaperGetInvestigatorWorkingPapersByIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/InvestigatorWorkingPaper/GetInvestigatorWorkingPapersById/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Investigator Working Papers By InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigatorWorkingPaperTrustInvestigatorGetInvestigatorWorkingPapersByIdInvestigationIdGet: async (investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2InvestigatorWorkingPaperTrustInvestigatorGetInvestigatorWorkingPapersByIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/InvestigatorWorkingPaper/TrustInvestigator/GetInvestigatorWorkingPapersById/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvestigatorWorkingPaperApi - functional programming interface
 * @export
 */
export const InvestigatorWorkingPaperApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Returns Investigator Working Paper File
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigatorWorkingPaperGetFileByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileView>> {
            const localVarAxiosArgs = await InvestigatorWorkingPaperApiAxiosParamCreator(configuration).apiV2InvestigatorWorkingPaperGetFileByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA Admin | Returns Investigator Working Paper File Stream
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigatorWorkingPaperGetFileStreamByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await InvestigatorWorkingPaperApiAxiosParamCreator(configuration).apiV2InvestigatorWorkingPaperGetFileStreamByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigator Working Paper By InvestigatorWorkingPaperId
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigatorWorkingPaperGetInvestigatorWorkingPaperByIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigatorWorkingPaperViewResponse>> {
            const localVarAxiosArgs = await InvestigatorWorkingPaperApiAxiosParamCreator(configuration).apiV2InvestigatorWorkingPaperGetInvestigatorWorkingPaperByIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigator Working Papers By InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigatorWorkingPaperGetInvestigatorWorkingPapersByIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigatorWorkingPaperViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigatorWorkingPaperApiAxiosParamCreator(configuration).apiV2InvestigatorWorkingPaperGetInvestigatorWorkingPapersByIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Investigator Working Papers By InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2InvestigatorWorkingPaperTrustInvestigatorGetInvestigatorWorkingPapersByIdInvestigationIdGet(investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigatorWorkingPaperViewIEnumerableResponse>> {
            const localVarAxiosArgs = await InvestigatorWorkingPaperApiAxiosParamCreator(configuration).apiV2InvestigatorWorkingPaperTrustInvestigatorGetInvestigatorWorkingPapersByIdInvestigationIdGet(investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * InvestigatorWorkingPaperApi - factory interface
 * @export
 */
export const InvestigatorWorkingPaperApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TA All | Returns Investigator Working Paper File
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigatorWorkingPaperGetFileByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any): AxiosPromise<FileView> {
            return InvestigatorWorkingPaperApiFp(configuration).apiV2InvestigatorWorkingPaperGetFileByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA Admin | Returns Investigator Working Paper File Stream
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigatorWorkingPaperGetFileStreamByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any): AxiosPromise<string> {
            return InvestigatorWorkingPaperApiFp(configuration).apiV2InvestigatorWorkingPaperGetFileStreamByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Investigator Working Paper By InvestigatorWorkingPaperId
         * @param {number} investigatorWorkingPaperId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigatorWorkingPaperGetInvestigatorWorkingPaperByIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any): AxiosPromise<InvestigatorWorkingPaperViewResponse> {
            return InvestigatorWorkingPaperApiFp(configuration).apiV2InvestigatorWorkingPaperGetInvestigatorWorkingPaperByIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Investigator Working Papers By InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigatorWorkingPaperGetInvestigatorWorkingPapersByIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigatorWorkingPaperViewIEnumerableResponse> {
            return InvestigatorWorkingPaperApiFp(configuration).apiV2InvestigatorWorkingPaperGetInvestigatorWorkingPapersByIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TrustInvestigator | Returns Investigator Working Papers By InvestigationId
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2InvestigatorWorkingPaperTrustInvestigatorGetInvestigatorWorkingPapersByIdInvestigationIdGet(investigationId: number, options?: any): AxiosPromise<InvestigatorWorkingPaperViewIEnumerableResponse> {
            return InvestigatorWorkingPaperApiFp(configuration).apiV2InvestigatorWorkingPaperTrustInvestigatorGetInvestigatorWorkingPapersByIdInvestigationIdGet(investigationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvestigatorWorkingPaperApi - object-oriented interface
 * @export
 * @class InvestigatorWorkingPaperApi
 * @extends {BaseAPI}
 */
export class InvestigatorWorkingPaperApi extends BaseAPI {
    /**
     * 
     * @summary TA All | Returns Investigator Working Paper File
     * @param {number} investigatorWorkingPaperId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigatorWorkingPaperApi
     */
    public apiV2InvestigatorWorkingPaperGetFileByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any) {
        return InvestigatorWorkingPaperApiFp(this.configuration).apiV2InvestigatorWorkingPaperGetFileByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA Admin | Returns Investigator Working Paper File Stream
     * @param {number} investigatorWorkingPaperId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigatorWorkingPaperApi
     */
    public apiV2InvestigatorWorkingPaperGetFileStreamByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any) {
        return InvestigatorWorkingPaperApiFp(this.configuration).apiV2InvestigatorWorkingPaperGetFileStreamByInvestigatorWorkingPaperIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Investigator Working Paper By InvestigatorWorkingPaperId
     * @param {number} investigatorWorkingPaperId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigatorWorkingPaperApi
     */
    public apiV2InvestigatorWorkingPaperGetInvestigatorWorkingPaperByIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId: number, options?: any) {
        return InvestigatorWorkingPaperApiFp(this.configuration).apiV2InvestigatorWorkingPaperGetInvestigatorWorkingPaperByIdInvestigatorWorkingPaperIdGet(investigatorWorkingPaperId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Investigator Working Papers By InvestigationId
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigatorWorkingPaperApi
     */
    public apiV2InvestigatorWorkingPaperGetInvestigatorWorkingPapersByIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigatorWorkingPaperApiFp(this.configuration).apiV2InvestigatorWorkingPaperGetInvestigatorWorkingPapersByIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TrustInvestigator | Returns Investigator Working Papers By InvestigationId
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestigatorWorkingPaperApi
     */
    public apiV2InvestigatorWorkingPaperTrustInvestigatorGetInvestigatorWorkingPapersByIdInvestigationIdGet(investigationId: number, options?: any) {
        return InvestigatorWorkingPaperApiFp(this.configuration).apiV2InvestigatorWorkingPaperTrustInvestigatorGetInvestigatorWorkingPapersByIdInvestigationIdGet(investigationId, options).then((request) => request(this.axios, this.basePath));
    }
}
